var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ui-file wrapper"
  }, [_vm.tip ? _c('div', {
    staticClass: "ui-file__tip form-block__tip"
  }, [_c('UiTip', {
    attrs: {
      "message": _vm.tip.message
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "upload-block",
    class: _vm.uploadClasses
  }, [_c('div', {
    staticClass: "ui-file__header"
  }, [_c('span', {
    staticClass: "upload-block-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "ui-file__container",
    class: {
      'ui-file__container-m-0': _vm.showInfoInput
    }
  }, [_vm.subtitle ? _c('span', {
    staticClass: "upload-block-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm.showInfoInput ? _c('div', {
    staticClass: "ui-file__container--link"
  }, [_vm.labelInputInfo ? _c('label', [_vm._v(_vm._s(_vm.labelInputInfo))]) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.infoInputValue,
      expression: "infoInputValue"
    }],
    attrs: {
      "type": "text",
      "readonly": true,
      "placeholder": _vm.placeholderInfo
    },
    domProps: {
      "value": _vm.infoInputValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.infoInputValue = $event.target.value;
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "ui-file__container--link"
  }, [_vm.labelInput ? _c('label', [_vm._v(_vm._s(_vm.labelInput))]) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modelProxy,
      expression: "modelProxy"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.modelProxy
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.modelProxy = $event.target.value;
      }, function ($event) {
        _vm.modelProxy = $event.target.value;
      }]
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.error,
      expression: "error"
    }],
    staticClass: "input-caption input-caption__error"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }